document.addEventListener('DOMContentLoaded', () => {
    const nextEvent = document.querySelector('.js-next-event');
    const nextEventLink = document.querySelector('.next-event-link');

    if (!nextEvent) return;

    const scrollToNextEvent = () => {
        nextEvent.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };

    // Scroll automatique au chargement
    setTimeout(scrollToNextEvent, 300);

    // Scroll au clic sur le lien
    if (nextEventLink) {
        nextEventLink.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToNextEvent();
        });
    }
});


jQuery(document).ready(function($) { 

	///////////////////
	/*  OK NEW THEME */
	//////////////////

	  /* Attention // uniquement si mobile ou tablette ! PODOM */
    $('#primary-menu li.menu-item-has-children > a').click(function(e) {
      $(this).parent().toggleClass('focus');
      e.preventDefault();
      // charge transition
  });

  var hadraHeader = document.querySelector("header.site-header");

// construct an instance of Headroom, passing the element

function isNavVisible(hadraHeader) {
  return (hadraHeader.classList.contains('open-s-menu') ? true : false );
}

	var options = {
	    offset : 60,

	    // scroll tolerance in px before state changes
	 //   tolerance : 0,
	    // or you can specify tolerance individually for up/down scroll
	    tolerance : {
	        up : 5,
	        down : 0
	    },

	  onUnpin: function() {
	    if ( isNavVisible(hadraHeader) ) {
	      this.elem.classList.remove(this.classes.unpinned);
	      this.elem.classList.add(this.classes.pinned);
	    }
	    else {
	      this.elem.classList.add(this.classes.unpinned);
	      this.elem.classList.remove(this.classes.pinned);
	    }
	  }
	};

	var headroom  = new Headroom(hadraHeader,options);

	// initialise
	headroom.init();


	/************************************************************/
/*************** SEARCH BTN / CONTAINER **********************/
/************************************************************/

const btnSearches = document.querySelectorAll('.btn-search');
const overlay = document.querySelector('#search-overlay');
const closeBtn = document.querySelector('.search-close');
const site = document.querySelector('#primary'); // wrapper général du thème

// Mémorise le bouton (desktop ou mobile) ayant ouvert la recherche
let activeSearchBtn = null;

// OUVERTURE / FERMETURE depuis les boutons de recherche
btnSearches.forEach((btnSearch) => {

    btnSearch.addEventListener('click', () => {

        const isOpen = overlay.classList.toggle('is-open');

        // On mémorise le bouton utilisé
        activeSearchBtn = btnSearch;

        // Synchronise les deux boutons
        btnSearches.forEach((btn) => {
            btn.setAttribute('aria-expanded', isOpen);
        });

        overlay.setAttribute('aria-hidden', !isOpen);

        // Activation du flou du site
        if (isOpen) {

            site.classList.add('blur-active');

            setTimeout(() => {
                overlay.querySelector('input[type="search"]')?.focus();
            }, 300);

        } else {

            site.classList.remove('blur-active');
            activeSearchBtn?.focus();

        }
    });

});


// FERMETURE via le bouton "close"
closeBtn.addEventListener('click', () => {

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', true);

    // Synchronise les deux boutons
    btnSearches.forEach((btn) => {
        btn.setAttribute('aria-expanded', false);
    });

    site.classList.remove('blur-active');

    // Retour du focus sur le bouton qui avait ouvert la recherche
    activeSearchBtn?.focus();
});


// FERMETURE avec la touche Échap
document.addEventListener('keydown', (e) => {

    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {

        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', true);

        // Synchronise les deux boutons
        btnSearches.forEach((btn) => {
            btn.setAttribute('aria-expanded', false);
        });

        site.classList.remove('blur-active');

        // Retour du focus sur le bouton qui avait ouvert la recherche
        activeSearchBtn?.focus();
    }

});
	


  /********************************/
  /* ********* HEADER HOME PAGE GALLERY *******/

  var swiper_headerGallery = new Swiper('.swiper-headerGallery', {
     // If we need pagination
       spaceBetween: 0, // try '5%' if you want
       slidesPerView: 1,
       loop: true,
       allowTouchMove: false,
       centeredSlides:false,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },

      pagination: {
         el: '.swiper-pagination-headerGallery',
         clickable: true
       }
   });   


  /********************************/
  /* ********* COLLAPSE SECTION CALENDRIER SUR LA HOME *******/


  document.querySelectorAll("[data-calendar-collapse]").forEach((collapse) => {
    const content = collapse.querySelector(".CalendarSection-Container");
    const button = collapse.querySelector(
        ".CalendarSection-Collapse-Button"
    );
    const buttonText = collapse.querySelector(
        ".CalendarSection-Collapse-ButtonText"
    );

    if (!content || !button || !buttonText) {
        return;
    }

    const previewHeight =
        Number.parseInt(collapse.dataset.previewHeight, 10) || 0;

    let isOpen = false;

    const setCollapsedHeight = () => {
        content.style.maxHeight = `${previewHeight}px`;
    };

    const openCalendar = () => {
        isOpen = true;

        collapse.classList.remove("is-collapsed");
        collapse.classList.add("is-open");

        button.setAttribute("aria-expanded", "true");
        buttonText.textContent = "Refermer le calendrier";

        /*
         * On part de la hauteur actuelle puis on anime jusqu’à la
         * hauteur réelle de tout le contenu.
         */
        content.style.maxHeight = `${previewHeight}px`;

        window.requestAnimationFrame(() => {
            content.style.maxHeight = `${content.scrollHeight}px`;
        });
    };

    const closeCalendar = () => {
        isOpen = false;

        /*
         * Si max-height vaut "none", on rétablit d’abord une valeur
         * numérique pour permettre au navigateur de l’animer.
         */
        content.style.maxHeight = `${content.scrollHeight}px`;

        window.requestAnimationFrame(() => {
            collapse.classList.remove("is-open");
            collapse.classList.add("is-collapsed");

            button.setAttribute("aria-expanded", "false");
            buttonText.textContent = "Voir le calendrier";

            setCollapsedHeight();
        });
    };

    button.addEventListener("click", () => {
        if (isOpen) {
            closeCalendar();
        } else {
            openCalendar();
        }
    });

    content.addEventListener("transitionend", (event) => {
        if (
            event.propertyName === "max-height" &&
            isOpen
        ) {
            /*
             * Une fois l’ouverture terminée, la hauteur redevient
             * libre. Le calendrier pourra ainsi grandir si son
             * contenu change.
             */
            content.style.maxHeight = "none";
        }
    });

    /*
     * État initial fermé.
     */
    setCollapsedHeight();
});




     $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-120;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });

    



/**********************************************************************/
/*************** SLIDER  / OTHER EVT DANS SINGLE EVT ****************/
/**********************************************************************/

   var swiper_other_evt = new Swiper('.js-swiper-other-evt', {

    slidesPerView: 1.5,
    speed: 1000,
    loopFillGroupWithBlank: true,
    spaceBetween:10,
    loop:true,
     breakpoints: {
          1024: { // a partir de 769
            slidesPerView: 3,
            spaceBetween:30,
          },

          500: { // a partir de 769
            slidesPerView: 2,
            spaceBetween:30,
          }
    },

    autoplay: {
      delay: 8000,
      disableOnInteraction: false
    },

    navigation: {
          nextEl: '.swiper-button-next-othevt',
          prevEl: '.swiper-button-prev-othevt'
      },
});


     $('.to_nicedropdown-js').niceSelect();
     
     $('.js-special_to_loadpage').on('change', function() {
         var href = this.value;
         document.location.href = href;
      });





       /********************************/
  /* ********* SLIDER INVITE PAGE ACCUEIL *******/

   var swiper_Breves_home = new Swiper('.swiper-LastBreve-home', {

     // If we need pagination
       spaceBetween: 20,
       slidesPerView: 1.3,
       loop: true,
       allowTouchMove: true,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },
       breakpoints: {
            1600: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 2.6,
            },

            1400: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3.1,
            },

             1024: { // a partir de 10224
              spaceBetween: 80,
              slidesPerView: 2.6,
            },
            768: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 2.6,
            },
            550: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 1.8,
            },
            425: { // a partir de 10224
              spaceBetween: 40,
              slidesPerView: 1.6,
            }
      
      },
       navigation: {
            nextEl: '.only-breves-next',
            prevEl: '.only-breves-prev'
      },
    
      pagination: {
        el: '.LastBreve-pagination-render',
        type:"fraction",
         renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
      },

       
    }

   });  
   
    //
   // INFINITE SCROLL DES BREVES 
    //
      if ($(".paginate_breves .pagination__next").length) {
      $('.list-infinite-breves').infiniteScroll({
          path: '.pagination__next',
          append: '.ResumeBreve',
          status: '.page-load-status',
          hideNav: '.pagination__next',
          history:false // ne change pas l'url
      });  
    }



    //// 
        // Slider deux colonnes dans les éléments en sticky
    ////
    var swiper_container_twocol_galery = new Swiper('.swiper_container_twocol_galery', {

      // If we need pagination
        spaceBetween: 20, // try '5%' if you want
        slidesPerView: 1,
        loop: true,
        centeredSlides:false,
         autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        breakpoints: {
            600: { // a partir de 769
              spaceBetween: 20,
              slidesPerView: 2,
            }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

    });

	////////////////////////
 	/*  FIN OK NEW THEME */
	/////////////////////////

  var header = $("#masthead");
  var h_header = $("#masthead").height();


  /* Active sticky nav link */

    const navLinks = document.querySelectorAll('.sticky-nav .link_to_scroll');

        const targets = [...navLinks]
            .map(link => {
                const id = link.getAttribute('href').split('#')[1];

                return {
                    link,
                    target: document.getElementById(id)
                };
            })
            .filter(item => item.target);

        const observer = new IntersectionObserver((entries) => {

            entries.forEach(entry => {

                if (!entry.isIntersecting) return;

                const current = targets.find(
                    item => item.target === entry.target
                );

                if (!current) return;

                navLinks.forEach(link => {
                    link.classList.remove('active');
                });

                current.link.classList.add('active');
            });

        }, {
            root: null,
            rootMargin: '-5% 0px -80% 0px',
            threshold: 0
        });

        targets.forEach(item => {
            observer.observe(item.target);
        });

   /*************/
    /*  LIGHTGALLERY */
   /*************/

  // $(".lightgallery-js").lightGallery({
  //      subHtmlSelectorRelative: true
  // }); 



    if ($(".lightgallery-js").length) {
    // Do something

      $( ".lightgallery-js" ).each(function() {
         var id = $(this).attr('id');
             lightGallery(document.getElementById(id), {
            plugins: [lgThumbnail],
            //selector: '.item-th-img',
            subHtmlSelectorRelative: true
        });
       
      });

    }
	  



   /*************/
    /* SUBMENU SCROLLING = ACTIVE + LINK TO SECTION // SIMPLEMENT POUR SINGLE ACTIVITY*/
    /*************/
  function scroll_to_section(href_dest, variable){
      //  if (href == "#realisations")  variable = 170;
    var offsetTop = href_dest === "#" ? 0 : $(href_dest).offset().top-topMenuHeight+1-variable-h_header;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 500);
  }

  if($('.container_scroll_js').length){
     // Cache selectors
  	var lastId,
      topMenu = $("#secondary-menu"),
      topMenuHeight = topMenu.outerHeight()+15,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });
    // PODOM MOBILE HERE
    // if(l_window < 769){
    //     topMenuHeight = $('#masthead').outerHeight();
    // }

  // Bind click handler to menu items
  menuItems.click(function(e){
    var href = $(this).attr("href");
    scroll_to_section(href, 40);
    e.preventDefault();
  });

 

  // var other_link =  $('.Intro-Link-js, .intro-link-js')
  // other_link.click(function(e){
  //   var href = $(this).attr("href"),
  //       offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
  //     $('html, body').stop().animate({ 
  //         scrollTop: offsetTop
  //     }, 300);
  //     e.preventDefault();
  // });

  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
      variable_top = 40;
      //if($(this).attr('id') == "realisations") variable_top = 170;else variable_top = 0;
       if ($(this).offset().top - variable_top - h_header < fromTop)
        return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems
           .parent().removeClass("active_menu")
           .end().filter("[href='#"+id+"']").parent().addClass("active_menu");
     }                  
  });

 } 





  /**************************************************************************************/
  /*********************** Flexible MODULE P / Slider de texte (avec titre cliquable) *********************************/
  /**************************************************************************************/

  var menu_pagination_mP = [];
  var titleMASlide = document.querySelectorAll('.swiper-container-mP .mP-TitleMobile');
  titleMASlide.forEach(function (sandwich, index) {
    menu_pagination_mP.push(sandwich.innerHTML);
  });

  var swiper_module_a = new Swiper('.swiper-container-mP', {


    // If we need pagination
      spaceBetween: 16, // try '5%' if you want
      centeredSlides: true,
      slidesPerView: 1.35,
      loop: true,

     pagination: {
           el: '.swiper-bullet-pagination',
           clickable: true
      },

      breakpoints: {
        769: { // a partir de 769

          spaceBetween: 20,
          centeredSlides: false,
          slidesPerView: 1,
          loop: false,

          pagination: {
          el: '.swiper-mP-txt',
          clickable: true,
            renderBullet: function (index, className) {
              return '<span class="button-label ' + className + '">' + (menu_pagination_mP[index]) + '</span>';
            },
          },
        }
      },
      on: {
      breakpoint: function (swiper) {
        this.update();
      }
    }

  });

  /**************************************************************************************/
  /*********************** FIN MODULE A / Services *********************************/
  /**************************************************************************************/





    var $number_result = 0;
    var $elt_no_result = $('.Other-Element');
    if($('.ItemIsotopeJsDay').length){
		$elt_no_result.hide();
	}
  	function filter_evt_calendar(filterValue){
  		 if(filterValue == "*"){
	        $('.ItemIsotopeJs').slideDown(300, function(){
	           var parent = $(this).parent().parent();
	          setTimeout(function(){   parent.slideDown(300); }, 10);
	        });

	        $elt_no_result.slideUp(300, function(){});
	      }
	      else{
	      	$number_result  = 0;
	        $( ".ItemIsotopeJs" ).each(function( index ) {
	          if ($(this).hasClass(filterValue)){
	          	 $number_result++;
	              $(this).slideDown(300, function(){

	                 if ($(this).parent().parent().css('display') == 'none'){
	                  var parent = $(this).parent().parent();
	                    setTimeout(function(){   parent.slideDown(300); }, 10);
	                 }

	              });
	          }else{
	            $(this).slideUp(300, function(){
	              if (!$(this).parent().parent().hasClass(filterValue)){
	                 var parent = $(this).parent().parent();
	                setTimeout(function(){  parent.slideUp(300); }, 10);
	             
	              }
	            });
	          }

	          if($number_result == 0){
	          	$elt_no_result.slideDown(300, function(){});
	          }else{
	          	$elt_no_result.slideUp(300, function(){});
	          }

	      });

        }

        var dest = $("#section-calendrier-top");
		var pos_top = parseInt(dest.offset().top);
		$('html,body').animate({
	        scrollTop: pos_top - 30}, 500
	    );
		return false;

  	}
    $('.NavSecondaire--Calendarjs').on( 'click', 'a', function() {

      var filterValue = $(this).attr('data-filter');
      filter_evt_calendar(filterValue);

      
       $('.NavSecondaire--Calendarjs a').removeClass('active');
       $(this).addClass('active');

      return false;
    });


      /* **************************************************  */
	  /* NICSELECT */
	  /* **************************************************  */
	  
	  $('.js-special_to_filter').on('change', function() {
	     var filterValue = this.value;
	     filter_evt_calendar(filterValue);

	  });

	  

	    $('.js-special_to_scroll').on('change', function() {
	     var href = this.value;
	     scroll_to_section(href, -100);
	    //scroll_to_section(href);
	  });

	   

    // fin ininite //



      /**********************************/
            /***** MODULE SLIDER DE TEXTE // EX : Témoignage ******/
        /**********************************/


       
       var swiper_text_fw = new Swiper('.swiper-container-mO', {
  
          spaceBetween: 20, // try '5%' if you want
          slidesPerView: 1.4,
          centeredSlides: true,
    //  centeredSlidesBounds: true,
          loop:true,
          speed:1000,

          pagination: {
            el: '.swiper-bullet-pagination',
            clickable: true
          },
          
           // navigation: {
           //    nextEl: '.nav-externe-slide-action .swiper-button-next',
           //    prevEl: '.nav-externe-slide-action .swiper-button-prev'
           //  },
            
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          },

            breakpoints: {
             390: { // a partir de 769
              spaceBetween: 20,
              slidesPerView: 1.6,
              centeredSlides: false,
            },

             500: { // a partir de 769
              spaceBetween: 30,
              slidesPerView: 2,
              centeredSlides: false,
            },

            800: { // a partir de 769
              spaceBetween: 30,
              slidesPerView: 2,
              centeredSlides: false,
            },
            1200: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3,
              centeredSlides: false,
            },
            1650: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3,
              centeredSlides: false,
            },
            
          }
          
 
    });
        



	// SCROLL / HEADER FIXED / STICKY NAV
	
	

	  // SCROLL S-MENU //
	 //  if (contain_s_menu.length){
	 // 	$( ".infos_p #secondary-menu a" ).click(function() {
		// 	$(".infos_p #secondary-menu a").removeClass('active');
		// 	$(this).addClass('active');
		//   	var tab_split = $(this).attr("href").split("/");
		//   	var dest = $(tab_split[tab_split.length-1]);
		//   	var pos_top = parseInt(dest.offset().top);
		//   	var h_h = parseInt(65+contain_s_menu.height() + 10 + admin_bar);
		  	
		//   $('html,body').animate({
		//         scrollTop: pos_top - h_h}, 500
		//     );
		// 	return false;
		// });

		// }


	
	// CARROUSSEL HOME PAGE


	 $( ".wpcf7-form input[type='text'],.wpcf7-form textarea" ).click(function() {
	  	$( this ).parent().parent().addClass('focus');
	});
	  $( ".wpcf7-form input[type='text'],.wpcf7-form textarea" ).focus(function() {
	  	$( this ).parent().parent().addClass('focus');
	});

	  $( ".wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
  		if($(this).val() != '') $( this ).parent().parent().addClass('focus');
 
	});




   /*  ***************************
  //  JS ADD 21 NOV 2024 
  // ******************************** */
	  	

     /*  ***************************
  //  ACCORDEON 
  // ******************************** */
	  	


    ////////////////
    //// GLOBAL accordion // Flexible, exemple : single fontaine
   ///////////////
   $('.accordion-section-content').hide(); //   $('.accordion-section-content:not(.first)').hide();
 

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      	
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');
       
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 					
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////



/**************************************************************************************/
/*********************** BLOC 16 - FLEXBILE  CAROUSEL D'IMAGE *********************************/
/**************************************************************************************/

var swiper_container_Carousel = new Swiper('.swiper-container-Carousel', {

  // If we need pagination
    spaceBetween: 20, // try '5%' if you want
    slidesPerView: 1,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    breakpoints: {
          1355: { // a partir de 769
            spaceBetween: 30,
            slidesPerView: 3,

          }, 1024: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 3,
     
          },
          601: { // a partir de 769
             spaceBetween: 20,
            slidesPerView: 2,
     
          }
      },

   // pagination: {
   //       el: '.swiper-bullet-pagination',
   //       clickable: true
   //  },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

});

	
/**************************************************************************************/
/*********************** LIGHTBOX / CLICK SUR GALERIE  *********************************/
/**************************************************************************************/


    if ($(".mFl16-Galerie_img.width_lighbox").length) {
    // Do something

      $( ".mFl16-Galerie_img.width_lighbox" ).each(function() {
         var id = $(this).attr('id');
             lightGallery(document.getElementById(id), {
            plugins: [lgThumbnail],
            selector: '.item-th-img',
            thumbnail: true
        });
       
      });

    }
	  
   /**************************************************************************************/
/*********************** SIMPLE GALLERIE DANS MODULE FLEXIBLE   *********************************/
/**************************************************************************************/


	var swiper_container_simple_galery = new Swiper('.swiper-container-simple-gallery', {

	  // If we need pagination
	    spaceBetween: 20, // try '5%' if you want
	    slidesPerView: 1,
	    loop: true,
	    centeredSlides:false,
	     autoplay: {
	        delay: 2500,
	        disableOnInteraction: true,
	    },
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev',
	    },

	});

	 



});